module.exports = __webpack_public_path__ + "static/Montserrat-Regular-27e50ffd6a14cbc8221c9dbd3b5208dc.otf";